module.exports = __webpack_public_path__ + "static/media/extendInfo.911f0233.jpg";